import styled from "styled-components";
import MaterialDatePicker from "material-ui-pickers/DatePicker";
import { Divider, Grid, List, ListItem, Button, DialogContent, IconButton } from "@material-ui/core";
import { PrimaryButton } from "components/Global/Buttons";

export const BlueResult = styled.div`
align-items:center;
color:#000;
display:flex;
flex-flow: column nowrap;  
padding:32px;
`;
export const FancyDivider = styled(Divider)`
&&& {
background-color: #000;
height:2px;
width:100%;
margin-bottom:4px;
margin-top:5px;  
}   
`;
export const RightAlignedValue = styled.div`
&& {
font-size:24px !important;
text-align:right;
}
`;
export const CenterAlignedValueGray = styled.div`
&& {
  display:block;
  font-family:Roboto-Medium, "Roboto Medium", Roboto;
  font-size:16px !important;
  font-style:normal;
  font-weight:500;
  text-align:center;
  color: #AAAAAA;
}
`;
export const CenterAlignedValue = styled.div`
&& {
font-size:24px !important;
text-align:center;
}
`;
export const DateValue = styled.div`
&& {
  font-size: 24px !important;
  text-align:center;
}
`;
export const WhiteBackground = styled.div`
text-align:center;
width:100%;
padding:12px 0;
margin-bottom:8px;
border-width: 0px;
background-color: rgba(255, 255, 255, 1);
box-sizing: border-box;
border-width: 1px;
border-style: solid;
border-color: rgba(6, 132, 201, 1);
border-radius: 0px;
-moz-box-shadow: none;
-webkit-box-shadow: none;
box-shadow: none;
`;
export const BigText = styled.div`
&& {
  font-size:36px !important;
  margin:8px 0;
}
`;
export const Label = styled.div`
text-transform:uppercase;
font-size:13px !important;
`;
export const CenterAlignedLabel = styled(Label)`
&& {
  text-align:center;
  color: #2D62A2;
}
`;
export const RightAlignedLabel = styled(Label)`
&& {  
text-align:right;
color: #2D62A2;
}
`;
export const PrimaryDataWrapper = styled.div`
display:flex;
flex-flow:column nowrap;
width:100%;  
`;
export const AddRow = styled.div`
display: flex;
flex-flow: row nowrap;
justify-content: space-between;
align-items: center;
`;
export const AddIconWrapper = styled.span`
font-size:32px;
`;
export const VerticalSpace = styled.div`
margin-top:4px;
margin-bottom:4px;
`;
export const Disclosure = styled.div`
&& {
  font-size:13px;
}
`;
export const AdditionalInfoButton = styled(Button)`
&& {
  padding-left:0;
  align-self:flex-start;
}
&&:hover {
  background:none;
}
`;
export const AdditionalInformationWrapper = styled.div`
&& {
  text-align:left; 
  width: 100%;
}
`;
export const FlexContainer = styled.div`
display:flex;
flex-flow:column nowrap;
justify-content:center;
align-items:center;
`;

export const StyledDialogContent = styled(DialogContent)` 
min-height: 455px;
max-height: 650px;
width: 900px;
`;

export const StyledMaterialDatePicker = styled(MaterialDatePicker)`
& input {
  font-size:17px;
}
& label {
  font-size:17px;
}
&& {
  border-bottom: 1px solid #2196F3;
  transition: 0.3s;
}  
`;
export const VerticalDivider = styled.div`
height: 34px;
border-right: 1px solid #cccccc;
`;

export const SelectedListItem = styled(ListItem)`
border-left: 3px solid rgba(43, 89, 121, 1);  
&&&&&& {    
  color: #2B5979;
  font-family: 'Roboto Medium', 'Roboto Regular', 'Roboto';
  font-weight: 500;
  font-style: normal;
  font-size: 17px;
}
&&:hover {
    background: rgba(245, 245, 245, 1);
}
`;
export const UnSelectedListItem = styled(ListItem)`
cursor: pointer;
border-left: 3px solid rgba(255, 255, 255, 0); 
&&&&&& {    
  color: #009DDF;
  font-family: 'Roboto Medium', 'Roboto Regular', 'Roboto';
  font-weight: 500;
  font-style: normal;
  font-size: 17px;
}
&&:hover {
    background: rgba(245, 245, 245, 1);
}
`;

export const ResultWrapper = styled(Grid)`  
&&&& {
  max-width: 100%;
}
`;
export const ItemList = styled(List)`
&&& {
  padding-top:1px;     
}
`;
export const ExportControlContainer = styled(Grid)`
min-width:250px;
padding-left: 72px;
`;
export const StyledHeaderButton = styled(Button)`
&& {
  margin-left: 4px;
  padding: 8px 8px 8px 2px;
  border-radius: 0;
  color: #2196f3;
  background: none;
  position: unset;
}
&&:hover {
  background: none;
}
`;
export const HeaderLeftContainer = styled(Grid)`
max-width:calc(100% - 250px) !important;
`;

export const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

export const StyledButtonWithPadding = styled(PrimaryButton)`
  && {
    margin-top: 10px;
  }
`;
